import { DataService } from './data.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { APIs } from '../config/api.constant';
import { ApiService } from './api.service';
import { HttpClient } from '@angular/common/http';
import { EventsUploadService } from './events-upload.service';

@Injectable({
  providedIn: 'root'
})
export class EventsService {
  constructor(
    private apiService: ApiService,
    private http: HttpClient,
    private eventsUploadService: EventsUploadService,
  ) {}



  getEventType() {
    return this.apiService.get(APIs.getEventType).pipe(map(response => {
      return response?.list;
    }));
  }

  getEventCategory() {
    return this.apiService.get(APIs.GetEventsCategory).pipe(map(response => {
      return response?.list;
    }));
  }


  getEventList(data): Observable<any> {
    return this.apiService.post(APIs.getEvents, data).pipe(
      map((response) => {
        return response?.list;
      })
    );
  }

  getEventDetail(data) {
    return this.apiService.get(APIs.getEventDetailById, data).pipe(map(response => {
      return response;
    }));
  }

  GetEventsImageType() {
    return this.apiService.get(APIs.GetEventsImageType).pipe(map(response => {
      return response;
    }));
  }

  GetEventsAttendeeType() {
    return this.apiService.get(APIs.GetEventsAttendeeType).pipe(map(response => {
      return response;
    }));
  }

  SaveEvents(data): Observable<any> {
    return this.apiService.post(APIs.SaveEvents, data).pipe(
      map((response) => {
        return response;
      })
    );
  }

  SaveEventsFormData(formData: FormData): Observable<any> {
    return this.eventsUploadService.postFormData(APIs.SaveEvents, formData).pipe(
      map((response) => response)
    );
  }

  getBinaryImage(event) {
    return new Promise((resolve, reject) => {
      let url: string | ArrayBuffer;
      console.log('came here 1', event.target);
      if (event.target.files && event.target.files[0]) {
        console.log(event.target.files[0].size);
        var reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (event) => {
          console.log('event', event);
          url = event.target.result;
          resolve(url);
        };
      }
    });
  }

  GetParticipantListDetails(data): Observable<any> {
    return this.apiService.post(APIs.GetParticipantListDetails, data).pipe(
      map((response) => {
        return response;
      })
    );
  }

  GetGuestList(data): Observable<any> {
    return this.apiService.post(APIs.GetGuestList, data).pipe(
      map((response) => {
        return response;
      })
    );
  }

  GuestApproveReject(data): Observable<any> {
    return this.apiService.post(APIs.GuestApproveReject, data).pipe(
      map((response) => {
        return response;
      })
    );
  }

  bulkInvEventApproval(data): Observable<any> {
    return this.apiService.post(APIs.eventApproval, data).pipe(
      map((response) => {
        return response;
      })
    );
  }

  SaveEventQRScan(data): Observable<any> {
    return this.apiService.post(APIs.SaveEventQRScan, data).pipe(
      map((response) => {
        return response;
      })
    );
  }

  GetParticipantListDetailsByID(data): Observable<any> {
    return this.apiService.post(APIs.GetParticipantListDetailsByID, data).pipe(
      map((response) => {
        return response;
      })
    );
  }

  GuestDetailsByInvitationId(id): Observable<any> {
    return this.apiService.get(APIs.GuestDetailsByInvitationId + '?InvitationId=' + id).pipe(
      map((response) => {
        return response;
      })
    );
  }

  getCompanyList(data): Observable<any> {
    return this.apiService.get(APIs.getCompanyListForHistory, data).pipe(
      map((response) => {
        return response;
      })
    );
  }

  GetCompanyListForParticipant(data): Observable<any> {
    return this.apiService.get(APIs.GetCompanyListForParticipant, data).pipe(
      map((response) => {
        return response;
      })
    );
  }

  EventDetailsByID(id) {
    return this.apiService.get(APIs.EventDetailsByID + '?EventId=' + id).pipe(map(response => {
      return response;
    }));
  }

  DeleteEvent(data): Observable<any> {
    return this.apiService.post(APIs.DeleteEvent, data).pipe(
      map((response) => {
        return response;
      })
    );
  }

  DeleteEventImage(data): Observable<any> {
    return this.apiService.post(APIs.DeleteEventImages, data).pipe(
      map((response) => {
        return response;
      })
    );
  }


  getAtendeeDetails(data): Observable<any> {
    return this.apiService.post(APIs.getAtendeeList, data).pipe(
      map((response) => {
        return response;
      })
    );
  }

  getBridgePlusReportsEvents(data): Observable<any> {
    return this.apiService.post(APIs.getEventsReportForBridgePlusCLA, data).pipe(
      map((response) => {
        return response;
      })
    );
  }

  getEventsReportData(body?: any): Observable<any> {
    return this.apiService.post(APIs.getEventsReportData, body).pipe(map(response => {
      return response;
    }));
  };

  // new apis
  eventCategorySave(data): Observable<any> {
    return this.apiService.post(APIs.saveCategoryEvent, data).pipe(
      map((response) => response)
    );
  }

  /**
   * Save event category with multipart form data (image as photoData + fileName).
   */
  eventCategorySaveFormData(formData: FormData): Observable<any> {
    return this.eventsUploadService.postFormData(APIs.saveCategoryEvent, formData).pipe(
      map((response) => response)
    );
  }

  getEvenetCategoryByParent(parentId, parkId) {
    return this.apiService.get(APIs.getCategoryEvent + '?ParentId=' + parentId + '&ParkId=' + parkId).pipe(map(response => {
      return response;
    }));
  }

  updateStatusOfEvent(data): Observable<any> {
    return this.apiService.post(APIs.updateEventCategoryStatus, data).pipe(
      map((response) => {
        return response;
      })
    );
  }

  fetchEventCategoryWise(data): Observable<any> {
    return this.apiService.post(APIs.categoryWiseEvent, data).pipe(
      map((response) => {
        return response?.data;
      })
    );
  }

  fetchEventByParkId(data): Observable<any> {
    return this.apiService.post(APIs.eventByPark, data).pipe(
      map((response) => {
        return response?.list;
      })
    );
  }

  activeDeactiveMainEvent(data): Observable<any> {
    return this.apiService.post(APIs.updateEventStatus, data).pipe(
      map((response) => {
        return response;
      })
    );
  }

  fetchSubCategoryDetails(id) {
    return this.apiService.get(APIs.getSubCategoryDetails + '?eventCategoryId=' + id).pipe(map(response => {
      return response;
    }));
  }

  SaveTeamDetails(data): Observable<any> {
    return this.apiService.post(APIs.SaveTeamDetails, data).pipe(
      map((response) => {
        return response;
      })
    );
  }

  getParticipantList(data): Observable<any> {
    return this.apiService.post(APIs.GetMemberdetails, data).pipe(
      map((response) => {
        return response;
      })
    );
  }

  GetParticipantListDetailsByTenantID(data): Observable<any> {
    return this.apiService.post(APIs.GetParticipantListDetailsByTenantID, data).pipe(
      map((response) => {
        return response;
      })
    );
  }

  getEventDetailById(id) {
    return this.apiService.get(APIs.getEventDetailById + '?EventId=' + id).pipe(map(response => {
      return response;
    }));
  }

  getCompanyListByParkId(id) {
    return this.apiService.get(APIs.GetCompanyListByPark + '?ParkId=' + id).pipe(map(response => {
      return response;
    }));
  }

  listParticipiantByEvent(data): Observable<any> {
    return this.apiService.post(APIs.GetParticipantDetailsByEventID, data).pipe(
      map((response) => {
        return response;
      })
    );
  }

  approveRejectEventPerticiaption(data): Observable<any> {
    return this.apiService.post(APIs.ApproveOrDeniedParticipant, data).pipe(
      map((response) => {
        return response;
      })
    );
  }

  fetchAllBigEvent(data): Observable<any> {
    return this.apiService.post(APIs.GetEventListByParkId, data).pipe(
      map((response) => {
        return response?.list;
      })
    );
  }

  getRegistredUserLiist(id): Observable<any> {
    return this.apiService.get(APIs.getRegistredUsers + '?eventCategoryId=' + id).pipe(
      map((response) => {
        return response;
      })
    );
  }

  downloadGuestListReport(formData: any) {
    // Your API endpoint
    const url = APIs.getDownloadGuestReport;
    return this.http.post(url, formData, { responseType: 'blob' })
  }

  downloadTeamIndividualList(formData: any) {
    // Your API endpoint
    const url = APIs.getDownloadTeamIndividual;
    return this.http.post(url, formData, { responseType: 'blob' })
  }

}
